import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export const url = '/libraries/management/types/baseMaterialCertificationType/entries'
export interface BaseMaterialCertificationType extends LibraryModel {
    new?: boolean
}
@Injectable({
    providedIn: 'root'
})
export class BaseMaterialCertificationTypeService {
    constructor(private http: HttpService) {}

    getAll(): Observable<BaseMaterialCertificationType[]> {
        return this.http.get(url)
    }

    remove(data: BaseMaterialCertificationType[]): Observable<boolean> {
        return this.http.delete(url, { data })
    }

    create(data: BaseMaterialCertificationType[]): Observable<unknown> {
        return this.http.post(url, { data })
    }
    update(data: BaseMaterialCertificationType[]): Observable<unknown> {
        return this.http.put(url, { data })
    }
}
